import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import {
  Button, Grid, TextField
} from '@material-ui/core'

import { postNewAup, getAupList } from '../../../../redux/actions'

import { handleAupContent, handleTextPrepper } from '../../../../utils'

import { NotificationToast } from '../../tools/Toast'

import { useQuill } from 'react-quilljs'
import 'quill/dist/quill.snow.css'

/**
 * Returns new AUP form
 */
const AUPnew = ({
  theme, modules, placeholder, formats,
  onBackTrack, classes, textClasses
}) => {
  const [aupName, setAupName] = useState('')
  const dispatch = useDispatch()

  const initAupQuill = useQuill({ theme, modules, formats, placeholder })
  const aupQuill = initAupQuill.quill
  const aupQuillRef = initAupQuill.quillRef

  const handleSave = async () => {
    const preppedAupName = handleTextPrepper(aupName)
    let aupContents = []
    let aupText = ''
    if (aupQuill) {
      const aupQuillLength = aupQuill.getLength()
      aupContents = aupQuill.getContents(0, aupQuillLength).ops
      aupText = aupQuill.getText(0, aupQuillLength)
    }
    if (aupContents.length !== 0) {
      const aupHTML = handleAupContent(aupContents)
      const aupSendText = handleTextPrepper(aupText)
      dispatch(postNewAup(preppedAupName, aupHTML, aupSendText, fireSuccess, fireFailure))
      onBackTrack()
    }
  }

  const fireSuccess = () => {
    NotificationToast(false, 'Successfully created AUP!')
    dispatch(getAupList())
  }

  const fireFailure = () => {
    NotificationToast(true, 'Failed to create AUP.')
  }

  const isEnabled = aupName.length > 0

  return (
    <>
      <Button
        className={`${classes.greenBtn} mt-1 mb-4`}
        onClick={(e) => { e.preventDefault(); onBackTrack() }}
        variant='contained'
      >
        <span className='font-weight-bold'>Back</span>
      </Button>
      <Grid item container direction='row'>
        <Grid item container direction='column' sm={8}>
          <h2 className='mb-4'>
            Create AUP
          </h2>
        </Grid>
        <Grid item container direction='column' sm={4}>
          <Grid item container direction='row' className='justify-content-end'>
            <Button
              className={`${classes.saveBtn} mt-2`}
              onClick={(e) => { e.preventDefault(); handleSave() }}
              variant='contained'
              disabled={!isEnabled}
            >
              <span className='font-weight-bold'>Save</span>
            </Button>
          </Grid>
        </Grid>
        <Grid item container direction='column' sm={12}>
          <Grid item container direction='row' className='mt-2'>
            <Grid item container direction='column' sm={8}>
              <h5>Name</h5>
              <TextField
                value={aupName}
                onChange={e => setAupName(e.target.value)}
                placeholder='Policy Name'
                name='aupName'
                id='aupName'
                error={aupName.length === 0}
                required
                InputProps={{ classes: textClasses }}
                fullWidth
                variant='filled'
              />
            </Grid>
          </Grid>
          <Grid item container direction='row' className='mt-4'>
            <Grid item container direction='column' sm={12}>
              <div className='mb-5' style={{ height: 300 }}>
                <div ref={aupQuillRef} />
              </div>
            </Grid>
          </Grid>
          <Grid item container direction='column' sm={12}>
            <Grid item container direction='row' className='justify-content-end'>
              <Button
                className={`${classes.saveBtn} mt-3`}
                onClick={(e) => { e.preventDefault(); handleSave() }}
                variant='contained'
                disabled={!isEnabled}
              >
                <span className='font-weight-bold'>Save</span>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default AUPnew
